import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from '../i18n/pl';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../../models";
import {Observable, of} from "rxjs";
import {AlertService} from "../../../services";
import {Country} from "../../../models/country";
import {Order} from "../../../models/order";

@Component({
    selector: 'split-payment-dialog',
    templateUrl: './splitPaymentDialog.component.html',
    styleUrls: ['./splitPaymentDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class SplitPaymentDialogComponent {
    action: string;
    dialogTitle: string;
    dialogRef: any;
    editMode: boolean = false;
    form: FormGroup;
    filteredOptions: Observable<User[]>;
    customers: User[];
    workers: User[];
    countries: Country[];
    order: Order;
    paymentMethods = [
        {
            'id': 'karta',
            'name': 'Karta'
        },
        {
            'id': 'gotówka',
            'name': 'Gotówka'
        }
    ];
    allowToConfirm = true;

    constructor(
        public matDialogRef: MatDialogRef<SplitPaymentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private alertService: AlertService,
        private formBuilder: FormBuilder,
    ) {
        this.translationLoader.loadTranslations(polish);

        this.order = _data.order;

        if (this.order.firstPaymentMethodValue === 0 || this.order.firstPaymentMethodValue === null) {
            this.order.firstPaymentMethodValue = this.order.priceGross;
        }

        this.form = this.formBuilder.group({
            paymentMethod: [this.order.paymentMethod, Validators.required],
            firstPaymentMethodValue: [this.order.firstPaymentMethodValue, Validators.required],
            secondPaymentMethod: [this.order.secondPaymentMethod, Validators.required],
            secondPaymentMethodValue: [this.order.secondPaymentMethodValue, Validators.required],
        });

        this.isTotalPriceValid();
    }

    get f() {
        return this.form.controls;
    }

    isTotalPriceValid(): boolean {
        let first = Number(this.form.getRawValue().firstPaymentMethodValue?this.form.getRawValue().firstPaymentMethodValue:0);
        let second = Number(this.form.getRawValue().secondPaymentMethodValue?this.form.getRawValue().secondPaymentMethodValue:0);
        let total = this.order.priceGross;

        if (first + second != total) {
            this.allowToConfirm = false;
        } else {
            this.allowToConfirm = true;
        }

        return this.allowToConfirm;
    }
}
